<p-toast></p-toast>
<div class="layout-topbar">
  <a class="layout-topbar-logo">
    <img class="hidden md:block" src="./assets/activitiesImages/micada_new_logo.png" alt="logo" width="80vw" height="100vh">
    <div class="hidden md:block" [ngStyle]="{'color': '#a66e23', 'font-size':'0.8rem'}"><b>{{ 'MICADA_PORTAL_VERISON_2.0'
        | translate}} <br>
        <div class="flex justify-content-center">{{ 'Since:2022-23' | translate}}</div>
      </b></div>
  </a>
  <div class="justify-content-center">
    <p-dropdown [(ngModel)]="selectedLang" [options]='[{name: "English", code:"en"}, {name: "Hindi",code:"hd"}]'
      optionLabel="name" (onChange)="languageChange($event)">
    </p-dropdown>
  </div>
  <div class="justify-content-center mx-2" *ngIf="showFinYearBlock">
    <p-dropdown [(ngModel)]="selectedYear" [options]='financialYears' optionLabel="name"
      (onChange)="yearChange($event)">
    </p-dropdown>
  </div>
  <a class="p-link layout-menu-button layout-topbar-button" (click)="appMain.toggleMenu($event)">
    <i class="pi pi-bars"></i>
  </a>

  <a class="p-link layout-topbar-menu-button layout-topbar-button" (click)="appMain.toggleTopMenu($event)">
    <i class="pi pi-ellipsis-v"></i>
  </a>

  <!-- <div class="field-checkbox justify-content-center">
        <p-dropdown [options]='[{name: "English"}, {name: "Hindi"}]' optionLabel="name"
            (onChange)="wrongNotification($event)">
        </p-dropdown>
    </div> -->
  <!-- <a *ngIf="isAdharValid==0 && this.aadharNumber" class="p-link layout-menu-button layout-topbar-button" style="color: red;width: 100%;" (click)="verifyAadhar()">
        Validate your Aadhar!
    </a> -->
  <a *ngIf="showKYCUpdateLink" class="p-link layout-menu-button layout-topbar-button kyc-button"
    (click)="openKYCPopUp()">
    KYC Update! <img class="hidden md:block" src="../../../../assets/activitiesImages/newitem.gif">
  </a>

  <div class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active':appMain.topMenuActive}">
    <h5 class="mt-2">{{userName}}</h5>
    <a class="p-link layout-topbar-button" (click)="menu.toggle($event)">
      <i class="pi pi-user"></i>
      <span (click)="logOut()">{{'LOGOUT'| translate}}</span>
    </a>
    <div style="position:absolute !important; margin-left:-35px !important;">
      <p-menu #menu [popup]="true" [model]="items" styleClass="prime-slider-override"></p-menu>
    </div>
  </div>
</div>
<p-dialog [(visible)]="showAadharVerDialog" [style]="{width: '550px'}" header="{{ 'VERIFY_AADHAR_NUMBER' | translate}}"
  [modal]="true" [baseZIndex]="-100" styleClass="p-fluid" (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid justify-content-center ver-dialog mt-2 outer-div"
      style="display: flex; flex-wrap:wrap">
      <img src="../../../../assets/aadhar/aadhar1.jpeg" alt="bg" style="width:100%;">
      <div class="inner-div">
        <div class="field md:col-12 col-12 aadhar-number">
          <label [style]="{color: 'rgb(3, 2, 2)'}">{{'AADHAR_NUMBER'| translate}}: <label class="px-2"
              [style]="{color: 'rgb(148, 9, 9)'}">{{ aadharNumber }}</label></label>
        </div>

        <!-- <div class="field md:col-12 col-12 edit-aadhar">
        <a class="d-flex flex-row-reverse" (click)="editAadharNumber()" style="cursor: pointer;">{{ "CLICK_HERE_TO_EDIT_AADHAR_NUMBER" | translate }}</a>
      </div> -->

        <div class="field md:col-12 col-12 otp-field">
          <label [style]="{color: 'rgb(3, 2, 2)'}">{{'ENTER_OTP'| translate}}:
          </label>
          <input pInputText maxlength="6" [(ngModel)]="aadharVerOTP" placeholder="OTP" type="number">
        </div>

        <div class="field md:col-12 col-12 resendOTP">
          <div class="timer resendOTP" *ngIf="timer > 0">Resend OTP in: {{ timer }} Seconds</div>
          <a *ngIf="timer === 0" (click)="resendOTP()" style="cursor: pointer;">Resend OTP</a>
          <!-- <p-button label="Resend OTP" severity="secondary" *ngIf="timer === 0" (click)="resendOTP()"></p-button> -->
        </div>

        <div class="field md:col-12 col-12">
          <button pButton pRipple label="{{ 'SUBMIT_OTP' | translate}}" class="p-button-success"
            (click)="submitOTP()"></button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text"
      (click)="hideDialog()"></button>
    <!-- <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button> -->
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="showKYCPopUpDialog" [style]="{width: '650px'}" header="{{ 'Complete KYC' | translate}}"
  [modal]="true" [baseZIndex]="-100" styleClass="p-fluid" (onHide)="hideKYCDialog()">
  <app-kyc *ngIf="showKYCPopUpDialog" [farmerDetails]="farmerData" (newItemEvent)="addItem($event)"></app-kyc>
  <!-- <ng-template pTemplate="content">
  </ng-template> -->

  <!-- <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text" (click)="hidePPIDDialog()"></button>
  </ng-template> -->
</p-dialog>